import { useTranslation } from "@/hooks/useTranslation";
import { VariantOption } from "@/networking/carts.api";

interface EnrollmentItemProps {
  productTitle: string;
  variantOptions: VariantOption[];
}

export default function EnrollmentItem({
  productTitle,
  variantOptions,
}: EnrollmentItemProps) {
  const { t } = useTranslation();

  return (
    <div className="my-1 pt-1 text-gray-700">
      <p className="mb-1 text-xs font-medium">{t("product")}:</p>
      <div className="space-y-0.5">
        <div className="flex items-center space-x-1">
          <div className="h-1 w-1 shrink-0 rounded-full bg-gray-600"></div>
          <span className="text-xs font-medium">{productTitle}</span>
        </div>

        {variantOptions.length > 0 && (
          <div className="mt-1 ml-2 flex flex-wrap gap-1.5">
            {variantOptions.map((o) => (
              <span
                key={o.title}
                className="inline-flex items-center justify-center rounded bg-gray-100 px-2 text-xs font-medium text-gray-900"
              >
                {o.value}
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
